export const plusIcon = `
<svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M21.8393 8V19.1607H33V21.8393H21.8393V33H19.1607V21.8393H8V19.1607H19.1607V8H21.8393Z" fill="#191919"/>
</svg>
`;
